<label class="close_button" (click)="closeDialog()">x</label>
<div class="uploadTemplateFile body" >
	<div class="divFile">
		<app-notification-message [errorMessage]="errorMessage" [successMessage]="successMessage">
        </app-notification-message>
		<div draggable="true" ngClass="{{dragAreaClass}}" class="custom-dropzone">
			<input id="fileInput" type="file" accept=".xls, .xlsx, .csv" (click)="onClick($event)"
                (change)="fileChange($event)" #fileInput style="display:none" />
				<!-- <input id="fileInput" type="file" accept=".xls, .xlsx, .csv" (click)="onClick($event)" 
                (change)="onFileSelected($event)" #fileInput style="display:none" /> -->
			<mat-icon id="cloudUpload" class="mat-icon material-icons upload-icon" aria-hidden="true">
				cloud_upload
			</mat-icon>
			<p id="dragDrop" *ngIf="!templateFile" class="dragdrop">Drag and Drop to Upload (or) </p>
			<p *ngIf="templateFile" class="dragdrop">{{templateFile.name}}</p>
			<label for="fileInput" class="btnFile">Browse File</label>
		</div>
		<button mat-raised-button class="btnImport" style="display: inline;" (click)="importFile()">
			Import
		</button>
		<!-- <button mat-raised-button class="btnImport" style="display: inline;" (click)="newimportFile()">
			Import
		</button> -->
	</div>
	<br>
	<div class="grid-agg">
		<hr style="margin:0; visibility: hidden;">
		<ag-grid-angular #agGrid style="width: 100%; height: 350px;" id="LIOS-GRID" class="ag-theme-balham" [theme]="'legacy'"
			[columnDefs]="columnDefs" [rowData]="rowData"  
			(gridReady)="onGridReady($event)" (window:resize)="sizeToFit()" [context]="context"
			 [enableCellTextSelection]="true" [ensureDomOrder]="true">
		</ag-grid-angular>
	</div>
	<button mat-button class="cancel" style="display: inline; background: transparent;border: none !important;"
		(click)="closeDialog()">
		CANCEL </button>
</div>